import React, {useEffect, useState} from 'react';
import { Redirect, Route, useLocation } from "react-router-dom";
import Loading from "../components/modules/Loading";
import useAuthToken from "../hooks/useAuthToken";
import useAuthenticatedUser from "../hooks/useAuthenticatedUser";


const PrivateRoute = ({ component: Component, ...rest }) => {

  const location = useLocation()
  const [loading, set_loading] = useState(true)
  const [is_authenticated, set_is_authenticated] = useState(false)
  const {clearToken, auth_token} = useAuthToken()
  const {refreshCurrentUser} = useAuthenticatedUser()

  useEffect(() => {
      refreshCurrentUser(auth_token).then(()=>{
          set_is_authenticated(true)
      }).catch(()=>{
          set_is_authenticated(false)
          clearToken()
      }).finally(()=>{
          set_loading(false)
      })
  }, [refreshCurrentUser]);

  if (loading) {
      return <Loading/>
  }

  return (
    <Route {...rest}>
      {is_authenticated ?
        <Component />
      :
        <Redirect to={{ pathname: "/signin", state: { from: location } }} />
      }
    </Route>
  );
};

export default PrivateRoute;
